
const env = process.env.REACT_APP_ENV;
const envSetting = {
      favicon: env === 'production' ? '/favicon.ico' : '/favicon-staging.ico',
      title: env === 'production' ? 'SuBuu' : env === 'staging' ? 'SuBuu Staging' : 'SuBuu Development',
      logo: env === 'production' ? '/images/logo.svg' : '/images/logo-staging.svg'
};

export default envSetting;